export default function SocialProofSection() {
  const testimonials = [
    {
      author: 'Fondateur — PRT Propreté',
      company: 'prtproprete.fr',
      avatar: 'ri-user-3-fill',
      avatarBg: 'from-emerald-400 to-teal-500',
      text: 'Site livré en 1 jour, exactement ce que je voulais\u00a0! Mes clients réservent maintenant en ligne directement depuis le site. ROI immédiat.',
      stars: 5,
    },
    {
      author: 'Fondatrice — MiraFlowers',
      company: 'miraflowers.fr',
      avatar: 'ri-user-heart-fill',
      avatarBg: 'from-pink-400 to-rose-500',
      text: 'Mon site e-commerce livré en moins de 7 jours, 100\u00a0% personnalisé et optimisé\u00a0! Paiement en ligne, SEO, mobile\u00a0… tout était déjà en place. Je recommande les yeux fermés\u00a0!',
      stars: 5,
    },
    {
      author: 'Gérant — Atelier Menuiserie',
      company: 'client UzunDigital',
      avatar: 'ri-user-2-fill',
      avatarBg: 'from-amber-400 to-orange-500',
      text: 'Très bonne communication du début à la fin. Le résultat dépasse mes attentes — design moderne, rapide, et mes clients me complimentent sur le site\u00a0!',
      stars: 5,
    },
  ];

  const stats = [
    { value: '+15', label: 'Sites livrés', icon: 'ri-global-line', color: 'text-emerald-500' },
    { value: '100%', label: 'Clients satisfaits', icon: 'ri-emotion-happy-line', color: 'text-teal-500' },
    { value: '48h', label: 'Délai moyen', icon: 'ri-timer-flash-line', color: 'text-emerald-500' },
    { value: '7j', label: 'Livraison max', icon: 'ri-calendar-check-line', color: 'text-teal-500' },
  ];

  return (
    <section className="py-16 sm:py-24 px-4 sm:px-6 bg-slate-50/70">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <p className="text-xs font-bold text-slate-400 uppercase tracking-[4px] mb-3">Ils nous font confiance</p>
          <div className="flex items-center justify-center gap-1.5 mb-3">
            {[1,2,3,4,5].map(s => (
              <i key={s} className="ri-star-fill text-amber-400 text-xl"></i>
            ))}
            <span className="text-slate-500 text-sm font-semibold ml-2">5/5 — 100% de satisfaction</span>
          </div>
        </div>

        {/* Stats rapides */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12">
          {stats.map((s, i) => (
            <div key={i} className="bg-white rounded-2xl p-5 text-center border border-slate-100">
              <div className="w-10 h-10 flex items-center justify-center mx-auto mb-2">
                <i className={`${s.icon} text-2xl ${s.color}`}></i>
              </div>
              <div className="text-3xl sm:text-4xl font-black text-slate-900">{s.value}</div>
              <div className="text-xs text-slate-400 font-semibold mt-1">{s.label}</div>
            </div>
          ))}
        </div>

        {/* Témoignages */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white rounded-2xl p-6 border border-slate-100 flex flex-col gap-4 relative overflow-hidden">
              {/* Guillemets déco */}
              <div className="absolute top-4 right-5 text-6xl font-serif text-slate-100 leading-none select-none">&ldquo;</div>

              {/* Stars */}
              <div className="flex items-center gap-0.5">
                {[1,2,3,4,5].map(s => (
                  <i key={s} className="ri-star-fill text-amber-400 text-sm"></i>
                ))}
              </div>

              {/* Texte */}
              <p className="text-sm sm:text-base text-slate-700 leading-relaxed flex-1 italic">
                &laquo;&nbsp;{t.text}&nbsp;&raquo;
              </p>

              {/* Auteur */}
              <div className="flex items-center gap-3 pt-2 border-t border-slate-100">
                <div className={`w-10 h-10 rounded-full bg-gradient-to-br ${t.avatarBg} flex items-center justify-center flex-shrink-0`}>
                  <i className={`${t.avatar} text-white text-base`}></i>
                </div>
                <div>
                  <p className="text-sm font-bold text-slate-900 leading-tight">{t.author}</p>
                  <p className="text-xs text-slate-400 font-medium">{t.company}</p>
                </div>
                <div className="ml-auto">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-emerald-50">
                    <i className="ri-verified-badge-fill text-emerald-500 text-base"></i>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
